module.exports = __webpack_public_path__ + "assets/mapbox-gl-js.42970416.svg";